import { useDispatch, useSelector } from 'react-redux'
import { getShowChannel } from 'redux/slices/interaction'
import { useEffect, useCallback } from 'react'

const useWebSocketEvent = (eventName: string, callback: (..._: any) => void) => {
    const dispatch = useDispatch()
    const wsChannel = useSelector(getShowChannel)

    const handler = useCallback(callback, [])

    useEffect(() => {
        wsChannel?.bind(eventName, handler)

        return () => {
            wsChannel?.unbind(eventName, handler)
        }
    }, [wsChannel, dispatch, handler, eventName])
}

export default useWebSocketEvent
